<div class="wrapper">
    <div class="ui divider"></div>

    <ui-banner *ngIf="hasTerminatedEmployee()" variant="warning" class="margin-y-5">
        <p>
            {{ 'document.terminatedMultiSignerBlocked' | translate }}
        </p>
    </ui-banner>
    <ng-container *ngFor="let request of allRequests; let i = index">
        <div class="signature-request">
            <p *ngIf="hasOrdering" class="ordering">{{ request.order || i + 1 }}.</p>
            <app-avatar [name]="true" [employee]="request.employee"></app-avatar>
            <div class="status">
                <p *ngIf="request.isSigned()">Signed on {{ request.completedAt | appDate }}</p>
                <ng-container *ngIf="!request.isSigned()">
                    <ui-badge *ngIf="!request.employee.isTerminated()" type="warning">{{
                        'document.signatureRequestStatus.notSigned' | translate | uppercase
                    }}</ui-badge>
                    <ui-badge *ngIf="request.employee.isTerminated()" type="danger">{{
                        'employeeStatus.terminated' | translate | translate | uppercase
                    }}</ui-badge>
                    <ui-button *ngIf="showRemind(request)" type="link" (click)="onRemind(request)">{{
                        'document.remind' | translate
                    }}</ui-button>
                </ng-container>
            </div>
        </div>
        <div class="ui divider"></div>
    </ng-container>
</div>
